import './css/style.css';


import React, { Component } from 'react';
import request from 'superagent';
import Map from "./Map";
import About from "./About";
import GDPRShit from "./GDPRShit";
import ItemsList from "./itemslist/ItemsList";
import InfoWindow from "./infowindow/InfoWindow";
import Terms from './Terms';
import MyForm from './MyForm';
import Header from './Header';
import Footer from './Footer';

import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import { ISLAND_CENTER } from "./config";

export class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sortedByDistance: true,
      data: []
    }
    // https://docs.google.com/spreadsheets/d/1V4FCWrsiXHKYKLCK7TohbcfokymRPIsI4_XrrCaUTvQ/edit?usp=sharing
    let url = "https://spreadsheets.google.com/feeds/list/1V4FCWrsiXHKYKLCK7TohbcfokymRPIsI4_XrrCaUTvQ/";
    let suffix = "/public/values?alt=json";
    this.dataURL = url + "1" + suffix;
    this.textURL = url + "2" + suffix;
    this.typologiesURL = url + "3" + suffix;

  }

  componentDidMount() {

    // TODO add time check
    // var storage = window.localStorage["gce_data"];

    // if (true || !storage) {
    request
      .get(this.textURL)
      .end(this.setText.bind(this));
    // } else {
    // storage = JSON.parse(storage);

    // this.categories = storage.categories;
    // this.typologies = storage.typologies;
    // this.init(storage.data);
    // }

  }

  setText(err, res) {


    this.text = res.body.feed.entry;

    request
      .get(this.typologiesURL)
      .end(this.setTypologies.bind(this));


  }


  setTypologies(err, res) {
    // TODO retrieve also categories from json
    this.categories = ["productores", "distribuidores", "servicios"];

    this.typologies = res.body.feed.entry.map((item, i) => {

      var typ = {
        id: +item['gsx$id'].$t,
        name: item['gsx$name'].$t,
        icon: item['gsx$icon'].$t,
        color: "#" + item['gsx$color'].$t,
      }
      return typ;
    });

    this.typologies.sort((a, b) => a.id - b.id);

    request
      .get(this.dataURL)
      .end(this.setItems.bind(this));

  }

  setItems(err, res) {


    request
      .get(this.dataURL)
      .end((err, res) => {

        window.localStorage["gce_data"] = JSON.stringify({
          data: res.body.feed.entry,
          typologies: this.typologies,
          text: this.text,
          categories: this.categories
        });

        this.init(res.body.feed.entry);

      });


  }




  init(items) {

    items = items.filter((item) => parseInt(item.gsx$tipologia.$t) != -1)

    let self = this;

    var data = items.map((item) => {

      const cc = item.gsx$coordinate.$t.split(",");
      const typology = +item.gsx$tipologia.$t;
      var newItem = {};
      newItem.name = item.gsx$nome.$t;
      newItem.path = item.gsx$url.$t;
      newItem.preview = item.gsx$preview.$t;
      newItem.icon = (typology !== -1) ? this.typologies[typology].icon : "";
      newItem.color = (typology !== -1) ? this.typologies[typology].color : "black";
      newItem.category = item.gsx$categoria.$t;
      newItem.typology = this.typologies[typology];
      newItem.descrizione = item.gsx$descrizione.$t;
      newItem.email = item.gsx$email.$t;
      newItem.immagine = item.gsx$immagine.$t;
      newItem.indirizzo = item.gsx$indirizzo.$t;
      newItem.preview = item.gsx$preview.$t;
      newItem.telefono = item.gsx$telefono.$t;
      newItem.web = item.gsx$web.$t;
      if (cc.length === 2) newItem.coords = { lat: parseFloat(+cc[0]), lng: parseFloat(+cc[1]) };
      return newItem;

    });





    if (window.navigator && "geolocation" in window.navigator) {

      window.navigator.geolocation.getCurrentPosition((position) => {
        setDistances(position.coords.latitude, position.coords.longitude);
      }, () => {
        // if user blocks geolocation
        setDistances(ISLAND_CENTER.latitude, ISLAND_CENTER.longitude)
      });

    } else {

      setDistances(ISLAND_CENTER.latitude, ISLAND_CENTER.longitude)

    }



    function setDistances(latitude, longitude) {
      data.forEach((item) => {
        if (item.coords) item.distance = getDistance(item.coords, { lat: latitude, lng: longitude })
      });


      function getDistance(pointA, pointB) {

        function deg2rad(deg) {
          return deg * (Math.PI / 180)
        }

        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(pointB.lat - pointA.lat);  // deg2rad below
        var dLon = deg2rad(pointB.lng - pointA.lng);
        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(deg2rad(pointA.lat)) * Math.cos(deg2rad(pointB.lat)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2)
          ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return Math.round(d);

      }

      complete.call(self);

    }

    function complete() {
      let currentData = data.filter((item) => {
        return item.category === this.categories[0];
      })

      this.setState({ currentData, data, categories: this.categories, typologies: this.typologies, currentCategory: this.categories[0] });
    }
  }

  onSortByDistance(b) {
    this.setState({
      sortedByDistance: b
    })
  }


  onCategoryFilter(category) {
    const currentData = this.state.data.filter((item) => {
      return item.category === category
    })
    this.setState({ currentData, currentCategory: category, currentTypology: null })
  }

  onTypologyFilter(typology) {

    let currentData;

    if (typology === null) {
      this.onCategoryFilter(this.state.currentCategory);
    } else {
      currentData = this.state.data.filter((item) => {
        return item.typology ? item.typology.name === typology : false
      });
      this.setState({ currentData, currentTypology: typology });
    }

  }

  render(a) {
    let listComponent;

    let text;
    if (this.text) {
      let texts = this.text.map((d, i) => d.gsx$faq.$t);
      text = texts.map((d, i) => <p key={i} dangerouslySetInnerHTML={{ __html: d }} />)
    } else {
      text = <p />
    }

    let map = () => (
      <Map state={this.state} />
    )

    return (

      <Router>


        <div id="wrapper">

          <Header />

          <div id="innerWrapper">
            <Switch>
              <Route exact path="/" render={map} />
              <Route path="/:path" render={({ match }) => {
                let section = match.params.path;
                if (section !== "terms" && section !== "info" && section !== "form") {
                  return <Map state={this.state} match={match} />
                } else {
                  return null
                }
              }} />
            </Switch>



            <Switch>

              <Route exact path="/" render={() => (
                <div id="rightcolumn">
                  <ItemsList
                    state={this.state}
                    onSortByDistance={this.onSortByDistance.bind(this)}
                    onCategoryFilter={this.onCategoryFilter.bind(this)}
                    onTypologyFilter={this.onTypologyFilter.bind(this)} />
                  <Footer />
                </div>

              )} />


              <Route path="/info" render={() => (
                <div className="centered">
                  <About
                    text={this.text}
                  />
                  <Footer />
                </div>
              )} />

              <Route path="/terms" render={(props) => (
                <div id="terms" className="centered">
                  <Terms {...props} />
                  <Footer />
                </div>
              )} />


              <Route path="/form" render={(props) => (
                <div className="centered">
                  <MyForm {...props} />
                  <Footer />
                </div>
              )} />


              <Route path="/:path" render={({ match }) => (
                <div id="rightcolumn">
                  <InfoWindow state={this.state} match={match} />
                  <Footer />
                </div>
              )} />


            </Switch>



          </div>

          <GDPRShit />
        </div>



      </Router >

    );
  }
}

export default App;






// WEBPACK FOOTER //
// ./src/App.js